import { NgIf } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Subscription } from "rxjs";
import { ModalComponent } from "../../../components/layout/modal/modal.component";
import { SelectOption } from "../../../models/option";
import { FormControlElement } from "../../models/form-control-element";
import { HorizontalWrapperComponent } from "../horizontal-wrapper/horizontal-wrapper.component";
import { RadioComponent } from "../radio/radio.component";
import { ValidatorComponent } from "../validator/validator.component";

@Component({
  selector: "app-radio-group",
  templateUrl: "./radio-group.component.html",
  styleUrls: ["./radio-group.component.scss"],
  standalone: true,
  imports: [HorizontalWrapperComponent, NgIf, RadioComponent, ValidatorComponent, ModalComponent],
})
export class RadioGroupComponent
  extends FormControlElement
  implements OnInit, OnChanges, OnDestroy
{
  @Input() options?: SelectOption[] | Observable<SelectOption[]>; //keuze an radiobuttons
  selectOptions: SelectOption[] = [];
  @Input() label: string = "";
  @Input() groupName: string = "radioGroup"; // deze naam moet uniek zijn per radiobutton groep
  @Input() type: string = "radio"; //radio of checkbox voor het type keuze veld.
  @Input() alignRight: boolean = false;
  @Input() marginBottom = true;
  @Input() noCols: boolean = false;
  @Input() inline: boolean = false;

  @Input() readOnly = false;
  protected readOnlyLabel = "";

  @Input() modal: boolean = false; // toon modal met meer info
  @Input() modalTitle: string = "Meer info"; // titel van de modal
  @Input() modalInfo!: HTMLDivElement; //  inhoud van de modal
  @Output() optionClicked = new EventEmitter<SelectOption>(); // functie om de keuze te bewaren
  @ViewChild("content") content!: ElementRef;

  protected optionControls: { [id: string | number]: FormControl } = {};
  private subs: Subscription[] = [];
  constructor(private modalService: NgbModal) {
    super();
  }
  ngOnDestroy(): void {
    this.clearSubscriptions();
  }

  ngOnInit(): void {
    this.loadOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["options"]) {
      this.loadOptions();
    }
  }

  clearSubscriptions() {
    this.subs.forEach((s) => s.unsubscribe());
    this.subs = [];
  }
  loadOptions() {
    if (this.options) {
      if (this.options instanceof Observable) {
        this.options.subscribe((opts) => {
          this.selectOptions = opts;
          this.setupControlsIfNeeded();
          this.setReadOnlyLabel();
        });
      } else {
        this.selectOptions = this.options;
        this.setupControlsIfNeeded();
        this.setReadOnlyLabel();
      }
    }
  }
  private setupControlsIfNeeded() {
    this.clearSubscriptions();
    this.optionControls = {};
    if (this.type === "checkbox" || this.type === "switch") {
      const selectedIds: any[] = Array.isArray(this.control?.value) ? this.control.value : [];
      this.selectOptions.forEach((opt) => {
        const checked = selectedIds.includes(opt.id);
        const fc = new FormControl(checked);
        this.optionControls[opt.id] = fc;
        const subscription = fc.valueChanges.subscribe(() => {
          const newSelected = this.selectOptions
            .filter((option) => this.optionControls[option.id].value)
            .map((option) => option.id);
          if (this.control) {
            this.control.setValue(newSelected);
            this.control.markAsDirty();
            this.control.markAsTouched();
          }
        });
        this.subs.push(subscription);
      });

      if (this.control) {
        const extSub = this.control.valueChanges.subscribe((value) => {
          const arrayValue = Array.isArray(value) ? value : [];
          this.selectOptions.forEach((option) => {
            const formControl = this.optionControls[option.id];
            const isSelected = arrayValue.includes(option.id);
            if (formControl && formControl.value == isSelected) {
              formControl.setValue(isSelected, { emitEvent: false });
            }
          });
        });
        this.subs.push(extSub);
      }
    }
  }
  setReadOnlyLabel() {
    this.readOnlyLabel =
      this.selectOptions.find((option) => option.id === this.control?.value)?.name ?? "";
  }

  open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      size: "lg",
    });
  }

  clickOption(option: SelectOption) {
    this.optionClicked.emit(option);
  }
}
